import { Element, useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useSelector } from "react-redux";
import type { Speaker } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import SyncedSpeakersSettings from "@/components/editor/shared/speakers/speakers-settings/synced-speakers-settings-component";
import { getAllSpeakers } from "@/features/speakers/speakers-reducer";

import SyncedSpeakerCard from "./speaker-card/synced-speaker-card-component";
import { CenteredHeader, SpeakerList } from "./speakers-component-styles";

type SyncedSpeakersProps = {
  speakers?: Speaker[];
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function SyncedSpeakers(props: SyncedSpeakersProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();
  const dashboardSpeakers = useSelector(getAllSpeakers);
  const speakers = props.speakers ?? dashboardSpeakers;

  const isEmpty = speakers.length === 0;
  const { enabled } = useEditor((state) => ({
    enabled: state.isEnabled(),
  }));

  if (!enabled && isEmpty) return null;

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper maxWidth="1248px">
          <CenteredHeader>
            <Element
              id="speakers-title"
              is={Text}
              element="h2"
              text="Speakers"
              pattern="headingTwo"
              data-testid="speakers-title"
            />
          </CenteredHeader>
          <SpeakerList>
            {enabled && isEmpty && <SyncedSpeakersSettings minimal />}
            {(speakers || []).map((speaker, idx) => (
              <SyncedSpeakerCard speaker={speaker} key={idx} />
            ))}
          </SpeakerList>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

SyncedSpeakers.craft = {
  isCanvas: true,
  custom: {
    displayName: "Synced Speakers",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: SyncedSpeakersSettings,
  },
};
